import { render, staticRenderFns } from "./OAuthFailureCallback.vue?vue&type=template&id=7c815280&lang=pug&"
import script from "./OAuthFailureCallback.vue?vue&type=script&lang=js&"
export * from "./OAuthFailureCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports